<template>
  <div class="cover flex-c">
    <div class="w30 h20 bg-color-white r10 t-c" tabindex="0">
        <div class="col-12 h17 pt10">
          <div class="mt10 mb10"><i class="iconfont icon-ai-password f50 color-danger"></i></div>
          <div class="color2 mt10">{{$store.state.auth_check.msg}}</div>
          <div class="col-12 mt10">
            <form onsubmit="return false;">
              <input type="password" class="w20 h4 lh40 r5 t-c b1" ref="auth_box" @keydown="keydown_event($event)" v-model="password" :class="{shaking:err}" autocomplete="on">
            </form>
          </div>
        </div>
        <div class="col-12">
          <button class="fl bg-color-primary lh35 w15 color-white rbl10" @click="keydown_event(13)"><span class="f14">[Entra].Si</span></button>
          <button class="fl bg-color-muted lh35 w15 color-white rbr10" @click="keydown_event(27)"><span class="f14">[ESC].No</span></button>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AuthCheck',
  data () {
    return {
      password: '',
      err: false
    }
  },
  created: function () {
    setTimeout(() => {
      this.$refs['auth_box'].focus();
    }, 50);
  },
  methods: {
    keydown_event(event) {
      if (typeof (event) == "number") {
        var keyCode = event;
      }
      else {
        var keyCode = event.keyCode;
      }
      switch (keyCode) {
        //ESC
        case 27:
          let focus = 'keyword'
          var is_select = 1
          if(this.$store.state.modal_box.type){
            if(this.$store.state.modal_box.type == 'whs'){
              focus = 'modal_box'
              is_select = 0
            }else{
              focus = 'modal_input'
            }
          }
          if(this.$store.state.win_box_app == 'search'){
            focus = 'search';
          }
          if(this.$store.state.pay){
            is_select = 0
            focus = 'pay';
          }
          this.$store.commit('setAuthCheck',{type:'',_this:this.$store.state.auth_check._this,focus:focus,check:false,select: is_select});
          break;
        //回车
        case 13:
          var post_data = {};
          post_data.password = this.password
          post_data.auth_type = this.$store.state.auth_check.type
          post_data.user_id = this.$store.state.user.id
          this.err = false
          this.post(this.api_url + "pos/auth_check", post_data).then((res) => {
            if(res.status == 1){
              this.$store.commit('setAuthCheck',{type:'',_this:this.$store.state.auth_check._this,focus:'',method:this.$store.state.auth_check.method,arg1:this.$store.state.auth_check.arg1,arg2:this.$store.state.auth_check.arg2,check:true,auth_user:res.data});
            }else{
              this.err = true
              this.$store.commit('setSound',true)
              this.$refs['auth_box'].select();
            }
          }).catch((err) => {});
        break;
      }
  },  
  }
}
</script>
<style scoped>
.cover div{
    outline:none;
}
</style>



// WEBPACK FOOTER //
// src/components/AuthCheck.vue